import angular from 'angular';
import TableService from './tableService.service';

let tableServiceModule = angular.module('tableService', []).service('tableService', TableService);

export default tableServiceModule;



// WEBPACK FOOTER //
// ./app/common/tableService/tableService.js